var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.718,
    height: 16.628,
    viewBox: "0 0 15.718 16.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ah{opacity:0.57;}.bh{fill:#8c99a5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ah",
    transform: "translate(-14.017)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M29.02,5.311h-.808a6.433,6.433,0,0,0-12.672,0h-.808a.714.714,0,0,0-.714.714v5.715a.714.714,0,0,0,.714.714h2.858a.714.714,0,0,0,.714-.714V6.026a.714.714,0,0,0-.714-.714H17a5.007,5.007,0,0,1,9.759,0h-.593a.714.714,0,0,0-.714.714v5.715a.714.714,0,0,0,.714.714h.714v1.618a.65.65,0,0,1-.649.649H25a.714.714,0,0,0-.673-.476H21.876a.714.714,0,0,0-.714.714v.953a.714.714,0,0,0,.714.714h2.447A.714.714,0,0,0,25,16.152h1.232a2.08,2.08,0,0,0,2.078-2.078V12.456h.714a.714.714,0,0,0,.714-.714V6.026A.714.714,0,0,0,29.02,5.311ZM16.875,11.027H15.446V6.74h1.429Zm11.431,0H26.877V6.74h1.429Z",
    transform: "translate(-14.017)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiocall);
export default __webpack_public_path__ + "static/media/audiocall.a50650f0.svg";
export { ForwardRef as ReactComponent };